var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"nav-main"},[_c('div',{staticClass:"site-container site-container-lg"},[_c('div',{staticClass:"row align-middle"},[_c('div',{staticClass:"logo"},[_c('logo')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }